import Rainbow from 'rainbowvis.js';

const colorScale = [
  {
    color: '#e83b68',
    min: 0,
  },
  {
    color: '#ec663b',
    min: 0.21,
  },
  {
    color: '#fecb33',
    min: 0.41,
  },
  {
    color: '#9ac43a',
    min: 0.61,
  },
  {
    color: '#55b364',
    min: 0.81,
  },
  {
    color: '#46b491',
    min: 1,
  },
];

const colorThemes = [
  {
    color: 'error',
    min: 0,
  },
  {
    color: 'error',
    min: 0.21,
  },
  {
    color: 'warning',
    min: 0.41,
  },
  {
    color: 'warning',
    min: 0.61,
  },
  {
    color: 'success',
    min: 0.81,
  },
  {
    color: 'success',
    min: 1,
  },
];

export function getScoreTheme(value: any) {
  const colorIndex = colorThemes.reduce(
    (currentScore: any, testScore: any, i: number) => {
      if (currentScore == null || testScore.min < value) {
        return i;
      }

      return currentScore;
    },
    null,
  );

  const endColor =
    colorThemes[colorIndex + 1] || colorThemes[colorThemes.length - 1];

  return endColor;
}

export function getScoreColor(value: number) {
  const colorIndex = colorScale.reduce(
    (currentScore: any, testScore: any, i: number) => {
      if (currentScore == null || testScore.min < value) {
        return i;
      }

      return currentScore;
    },
    null,
  );
  const startColor = colorScale[colorIndex];
  const endColor =
    colorScale[colorIndex + 1] || colorScale[colorScale.length - 1];
  const rainbow = new Rainbow();
  rainbow.setSpectrum(startColor.color, endColor.color);

  // This is how much between the `startColor` and `endColor` `value` is
  const colorRatio = value - endColor.min;

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(colorRatio)) {
    return rainbow.colourAt(0);
  }

  return rainbow.colourAt(colorRatio);
}

/**
 * Returns a specification of the human style (label & className) for a given
 * Letrus Score
 *
 * @param {Number} totalScore
 * @return {Object} humanScore
 * @return {String} humanScore.label
 * @return {Number} humanScore.min
 * @return {String} humanScore.className
 * @return {String} humanScore.color
 */

export default function getHumanScore(totalScore: number): any {
  const humanScores = [
    {label: 'Você não foi bem', min: 0, className: 'red'},
    {label: 'Você não foi muito bem', min: 0.2, className: 'yellow'},
    {label: 'Você foi bem', min: 0.5, className: 'green'},
    {label: 'Você foi muito bem', min: 0.7, className: 'green'},
  ];

  const result = humanScores.reduce((currentScore: any, testScore: any) => {
    if (!currentScore || testScore.min < totalScore) {
      return testScore;
    }

    return currentScore;
  }, null);

  return {
    ...result,
    color: getScoreColor(totalScore),
  };
}
